import $ from 'jquery';
import gsap from "gsap/dist/gsap";
import ScrollTrigger from "gsap/dist/ScrollTrigger";
import Rellax from "rellax/rellax";

gsap.registerPlugin(ScrollTrigger);

document.arrive(".interni", {existing: true}, function (){

  gsap.to(".section-title-3 h2", {
    x: 0,
    opacity: 1,
    duration: 1,
    scrollTrigger: {
      trigger: ".section-title-3",
      toggleClass: "no-opacity",
      toggleActions: "restart none resume none"
    }
  })

  gsap.to(".text-servizi-first-line", {
    duration: 1,
    scrollTrigger: {
      trigger: ".text-servizi-first-line",
      toggleClass: "animate",
      toggleActions: "restart none resume none"
    }
  })
  gsap.to(".text-servizi-second-line", {
    duration: 1,
    scrollTrigger: {
      trigger: ".text-servizi-second-line",
      toggleClass: "animate",
      toggleActions: "restart none resume none"
    }
  })
  gsap.to(".text-servizi-third-line", {
    duration: 1,
    scrollTrigger: {
      trigger: ".text-servizi-third-line",
      toggleClass: "animate",
      toggleActions: "restart none resume none"
    }
  })
  gsap.to(".text-servizi-fourth-line", {
    duration: 1,
    scrollTrigger: {
      trigger: ".text-servizi-fourth-line",
      toggleClass: "animate",
      toggleActions: "restart none resume none"
    }
  })
  gsap.to(".text-servizi-fifth-line", {
    duration: 1,
    scrollTrigger: {
      trigger: ".text-servizi-fifth-line",
      toggleClass: "animate",
      toggleActions: "restart none resume none"
    }
  })

  gsap.to(".text-ricerca-innovazione-first-line", {
    duration: 1,
    scrollTrigger: {
      trigger: ".text-ricerca-innovazione-first-line",
      toggleClass: "animate",
      toggleActions: "restart none resume none"
    }
  })
  gsap.to(".text-ricerca-innovazione-second-line", {
    duration: 1,
    scrollTrigger: {
      trigger: ".text-ricerca-innovazione-second-line",
      toggleClass: "animate",
      toggleActions: "restart none resume none"
    }
  })
  gsap.to(".text-ricerca-innovazione-third-line", {
    duration: 1,
    scrollTrigger: {
      trigger: ".text-ricerca-innovazione-third-line",
      toggleClass: "animate",
      toggleActions: "restart none resume none"
    }
  })
  gsap.to(".text-ricerca-innovazione-fourth-line", {
    duration: 1,
    scrollTrigger: {
      trigger: ".text-ricerca-innovazione-fourth-line",
      toggleClass: "animate",
      toggleActions: "restart none resume none"
    }
  })
  gsap.to(".text-ricerca-innovazione-fifth-line", {
    duration: 1,
    scrollTrigger: {
      trigger: ".text-ricerca-innovazione-fifth-line",
      toggleClass: "animate",
      toggleActions: "restart none resume none"
    }
  })
  gsap.to(".text-ricerca-innovazione-sixth-line", {
    duration: 1,
    scrollTrigger: {
      trigger: ".text-ricerca-innovazione-sixth-line",
      toggleClass: "animate",
      toggleActions: "restart none resume none"
    }
  })
  gsap.to(".text-ricerca-innovazione-seventh-line", {
    duration: 1,
    scrollTrigger: {
      trigger: ".text-ricerca-innovazione-seventh-line",
      toggleClass: "animate",
      toggleActions: "restart none resume none"
    }
  })
  gsap.to(".text-ricerca-innovazione-eighth-line", {
    duration: 1,
    scrollTrigger: {
      trigger: ".text-ricerca-innovazione-eighth-line",
      toggleClass: "animate",
      toggleActions: "restart none resume none"
    }
  })
  gsap.to(".text-ricerca-innovazione-ninth-line", {
    duration: 1,
    scrollTrigger: {
      trigger: ".text-ricerca-innovazione-ninth-line",
      toggleClass: "animate",
      toggleActions: "restart none resume none"
    }
  })


  gsap.to(".soluzioni-su-misura h6", {
    x: 0,
    opacity: 1,
    duration: 1,
    scrollTrigger: {
      trigger: ".soluzioni-su-misura",
      toggleActions: "restart none resume none",
    }
  })

  gsap.to(".punto-di-forza h6", {
    x: 0,
    opacity: 1,
    duration: 1,
    scrollTrigger: {
      trigger: ".punto-di-forza",
      toggleActions: "restart none resume none",
    }
  })


})

const rellax = new Rellax('.rellax-image');